import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { ErrorLoggerService } from "./error-logger.service";
import { Router } from "@angular/router";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const message = error && error.message ? error.message : '';
     if (
        !navigator.onLine ||
        error.status === 0 ||
        message.indexOf('ERR_INTERNET_DISCONNECTED') !== -1 ||
        message.indexOf('ERR_ADDRESS_UNREACHABLE') !== -1
      ) {
        console.warn('Network issue detected:', error);
        return;
      }
    const logger = this.injector.get(ErrorLoggerService);
    const router = this.injector.get(Router);

    logger.log({
      ErrorType: "ClientRuntimeError",
      ErrorMessage: error && error.message ? error.message : error.toString(),
      Url: window.location.href,
      Route: router.url,
      RawResponse: error && error.stack ? error.stack : ""
    });

    console.error("Global Error Caught: ", error);
  }
}
